import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import FilterView from "../../common/filter";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import { Form } from "react-bootstrap";
import type LustrationReportsViewModel from "viewModels/enforcement/lustrationReports/lustrationReportsViewModel";
import CountrySelect from "views/common/countrySelect";
import LicensePlateInput from "controls/licensePlateInput";
import DatePickerBox from "controls/datePickerBox";
import { startOfEDAZDistribution } from "config";
import { addYears } from "date-fns";
import { disabledDaysRange } from "utils/dateUtils";

export interface LustrationReportsFiltersProps {
  vm: LustrationReportsViewModel;
}

const LustrationReportsFilters = observer((props: LustrationReportsFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <Form.Row>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="countryId">
          <FormLabel>{vm.translateFilterAttribute("countryId")}</FormLabel>
          <CountrySelect vm={vm.countrySelectViewModel} placeholder={vm.translateFilterAttribute("countryIdPlaceholder")} />
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="licensePlate">
          <FormLabel>{vm.translateFilterAttribute("licensePlate")}</FormLabel>
          <LicensePlateInput placeholder={vm.translateFilterAttribute("licensePlatePlaceholder")} />
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="_eventOccurredAtSinceDate">
          <FormLabel>{vm.translateFilterAttribute("validSinceDate")}</FormLabel>
          <DatePickerBox
            placementOverlay="top-start"
            strategyOverlay="fixed"
            fromMonth={startOfEDAZDistribution}
            toMonth={addYears(new Date(), 1)}
            disabledDays={disabledDaysRange(addYears(new Date(), 1), startOfEDAZDistribution)}
            placeholder={vm.translateFilterAttribute("validSinceDatePlaceholder")}
          />
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="_eventOccurredAtUntilDate">
          <FormLabel>{vm.translateFilterAttribute("validUntilDate")}</FormLabel>
          <DatePickerBox
            placementOverlay="top-start"
            strategyOverlay="fixed"
            fromMonth={startOfEDAZDistribution}
            toMonth={addYears(new Date(), 1)}
            disabledDays={disabledDaysRange(addYears(new Date(), 1), startOfEDAZDistribution)}
            placeholder={vm.translateFilterAttribute("validUntilDatePlaceholder")}
          />
        </FormGroup>
      </Form.Row>
    </FilterView>
  );
});

export default LustrationReportsFilters;
